import Notification from "../../../components/Common/Notification/index";
import * as shirtCategoryApi from "../../../services/shirtcategory";
import {
  ADD_SHIRTCATEGORY_FAILURE,
  ADD_SHIRTCATEGORY_REQUEST,
  ADD_SHIRTCATEGORY_SUCCESS,
  DELETE_SHIRTCATEGORY_FAILURE,
  DELETE_SHIRTCATEGORY_REQUEST,
  DELETE_SHIRTCATEGORY_SUCCESS,
  GET_SHIRTCATEGORIES_FAILURE,
  GET_SHIRTCATEGORIES_REQUEST,
  GET_SHIRTCATEGORIES_SUCCESS,
  GET_SINGLE_SHIRTCATEGORY_FAILURE,
  GET_SINGLE_SHIRTCATEGORY_REQUEST,
  GET_SINGLE_SHIRTCATEGORY_SUCCESS,
  UPDATE_SHIRTCATEGORY_FAILURE,
  UPDATE_SHIRTCATEGORY_REQUEST,
  UPDATE_SHIRTCATEGORY_SUCCESS,
} from "./shirtcategory.actionType";

export const requestAddShirtCategory = () => {
  return {
    type: ADD_SHIRTCATEGORY_REQUEST,
  };
};

export const addShirtCategorySuccess = (data) => {
  return {
    type: ADD_SHIRTCATEGORY_SUCCESS,
    data,
  };
};

export const addShirtCategoryFailure = (message) => {
  return {
    type: ADD_SHIRTCATEGORY_FAILURE,
    message,
  };
};

export const addShirtCategory = (data) => {
  return (dispatch) => {
    dispatch(requestAddShirtCategory());
    return shirtCategoryApi
      .addShirtCategory(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addShirtCategorySuccess(data));
        return Notification(
          "",
          `${data.Name} ShirtCategory added Successfully `,
          "success"
        );
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addShirtCategoryFailure());
        Notification("", errorMessage, "error");
        throw errorMessage;
      });
  };
};

export const requestGetShirtCategories = () => {
  return {
    type: GET_SHIRTCATEGORIES_REQUEST,
  };
};

export const getShirtCategoriesSuccess = (data) => {
  return {
    type: GET_SHIRTCATEGORIES_SUCCESS,
    data,
  };
};

export const getShirtCategoriesFailure = (message) => {
  return {
    type: GET_SHIRTCATEGORIES_FAILURE,
    message,
  };
};

export const getShirtCategories = () => {
  return (dispatch) => {
    dispatch(requestGetShirtCategories());
    return shirtCategoryApi
      .getShirtCategories()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getShirtCategoriesSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getShirtCategoriesFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSingleShirtCategory = () => {
  return {
    type: GET_SINGLE_SHIRTCATEGORY_REQUEST,
  };
};

export const getSingleShirtCategorySuccess = (data) => {
  return {
    type: GET_SINGLE_SHIRTCATEGORY_SUCCESS,
    data,
  };
};

export const getSingleShirtCategoryFailure = (message) => {
  return {
    type: GET_SINGLE_SHIRTCATEGORY_FAILURE,
    message,
  };
};

export const getSingleShirtCategory = (id) => {
  return (dispatch) => {
    dispatch(requestgetSingleShirtCategory());
    return shirtCategoryApi
      .getSingleShirtCategory(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSingleShirtCategorySuccess(data));
        return;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSingleShirtCategoryFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestDeleteShirtCategory = () => {
  return {
    type: DELETE_SHIRTCATEGORY_REQUEST,
  };
};

export const deleteShirtCategorySuccess = (data) => {
  return {
    type: DELETE_SHIRTCATEGORY_SUCCESS,
    data,
  };
};

export const deleteShirtCategoryFailure = (message) => {
  return {
    type: DELETE_SHIRTCATEGORY_FAILURE,
    message,
  };
};

export const deleteShirtCategory = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteShirtCategory());
    return shirtCategoryApi
      .deleteShirtCategory(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deleteShirtCategorySuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deleteShirtCategoryFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdateShirtCategory = () => {
  return {
    type: UPDATE_SHIRTCATEGORY_REQUEST,
  };
};

export const updateShirtCategorySuccess = (data) => {
  return {
    type: UPDATE_SHIRTCATEGORY_SUCCESS,
    data,
  };
};

export const updateShirtCategoryFailure = (message) => {
  return {
    type: UPDATE_SHIRTCATEGORY_FAILURE,
    message,
  };
};

export const updateShirtCategory = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdateShirtCategory());
    return shirtCategoryApi
      .updateShirtCategory(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updateShirtCategorySuccess(data));
        return Notification(
          "",
          `${data.Name} ShirtCategory updated Successfully `,
          "success"
        );
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updateShirtCategoryFailure());
        Notification("", errorMessage, "error");
      });
  };
};
